import { readJson } from "../types"

export interface ImageSearchResult {
  title: string
  image_url: string
  thumbnail_url: string
  source_url: string | null
}

export async function fetchImages(query: string): Promise<ImageSearchResult[]> {
  const response = await fetch(
    `/api/v1/image_search?${new URLSearchParams({ query })}`,
    { credentials: "include" }
  )
  const body = await readJson<ImageSearchResult[]>(response)
  if (!response.ok)
    throw new Error(
      body.error || body.errors?.join(", ") || "Picture search is unavailable."
    )
  return body.data
}
